module.exports = __webpack_public_path__ + "static/img/avatar.63d5e120.png";